import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useLocalAppState } from '@/contexts/LocalAppStateContext';
import { isNativeApp } from '@/lib/platform/runtime';

export default function OnboardingGate({ children }: { children: ReactNode }) {
  const { state } = useLocalAppState();
  const { pathname } = useLocation();
  if (isNativeApp() && state.onboardingStatus === 'new' && pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}
